<template>
  <v-container>
    <v-card>
      <v-card-title class="text-capitalize">
        {{ $t("about.label") }}
      </v-card-title>
      <v-card-subtitle class="mt-2">
        <p>
          {{ $t("about.description") }}
        </p>
      </v-card-subtitle>
      <v-card-title>{{ $t("features.label") }}</v-card-title>
      <v-card-text>
        <ul class="mr-4">
          <li v-for="f in featuresLength" :key="f" class="headline">
            {{ $t("features.items.f" + f) }}
          </li>
        </ul>
      </v-card-text>
      <v-card-title>{{ $t("resources") }}</v-card-title>
      <v-card-text>
        <ul class="mr-4 text-capitalize">
          <li v-for="(r, s) in resources" :key="s" class="headline">
            <a :href="r.url" target="_blanc">{{ r.title }}</a>
          </li>
        </ul>
      </v-card-text>
      <v-card-title>{{ $t("app_owner") }}</v-card-title>
      <v-card-text>
        <ul class="mr-4 text-capitalize">
          <li v-for="(author, a) in authors" :key="a" class="headline">
            {{ author }}
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { features } from "../locales/ar.json";

export default {
  name: "about",
  data: () => ({
    featuresLength: Object.keys(features.items).length,
    resources: [
      {
        title: "hisnmuslim website",
        url: "https://hisnmuslim.com/",
      },
      {
        title: "hisn muslim scrapping",
        url: "https://github.com/mohssineAboutaj/hisn-muslim-scrapping",
      },
      {
        title: "hisn muslim app repository (coming soon)",
        url: "",
      },
    ],
    authors: ["Mohssine Aboutaj", "Yassine Marmoud"],
  }),
  metaInfo: {
    title: "حول التطبيق",
  },
};
</script>
